module.exports = __webpack_public_path__ + "img/data_mapping.940df921.svg";